import ColumnPage from './ColumnPage';

export default function Science() {
  return (
    <ColumnPage
      column="science"
      title="MAD SCIENTISTS"
      description="Deep dives into scientific concepts and discoveries. Physics, quantum theory, biology, emerging sciences, and applied innovation."
    />
  );
}
